import { useEffect, useState } from "react";
import MuiButton from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import vectorIcon from "../../../assets/_VectorIcon_.svg";
import styles from "./styles.module.scss";
import Switch from "@mui/material/Switch/Switch";
import { IConfiguration } from "../../../@types/configuration.type";
import { ApiException } from "../../../services/api/ApiException";
import { addOrUpdateConfigurations, searchConfigurationsByKeys } from "../../../services/api/Configurations/ConfigurationService";

export const AccountConfiguration: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isFinancialModeEnabled, setIsFinancialModeEnabled] = useState(false);
  

  const fetchFinancialStatus = async () => {
    try {
      setLoading(true);
      const response = await searchConfigurationsByKeys(["CONFIGURATION_ENABLE_FINANTIAL"]);

      if (response instanceof ApiException) {
        throw new Error(response.message);
      }

      const status = response.result?.find((config: IConfiguration) => config.key === "CONFIGURATION_ENABLE_FINANTIAL");

      setIsFinancialModeEnabled(status?.value === "true");
    } catch (error) {
      console.error("Erro ao buscar status financeiro:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = async () => {
    const newStatus = !isFinancialModeEnabled;
    setIsFinancialModeEnabled(newStatus);

    try {
      const response = await addOrUpdateConfigurations([
        { key: "CONFIGURATION_ENABLE_FINANTIAL", value: newStatus.toString() },
      ]);

      if (response instanceof ApiException) {
        throw new Error(response.message);
      }

      console.log("Modo Financeiro atualizado:", newStatus ? "Ativado" : "Desativado");
    } catch (error) {
      console.error("Erro ao atualizar status financeiro:", error);
      setIsFinancialModeEnabled(!newStatus);
    }
  };

  useEffect(() => {
    fetchFinancialStatus();
  }, []);

  return (
    <div className={styles.financial}>
      <div className={styles.back}>
        <MuiButton className={styles.buttonMui} onClick={() => navigate("/configurations")}>
        {vectorIcon && <img src={vectorIcon} />}
        Voltar a tela anterior
        </MuiButton>
      </div>
      <div className={styles.titleAndBtnCreate}>
        <h1>Configuração da Conta</h1>
      </div>
      <hr />

      <h4>
        Habilitar Modo Financeiro:
        <Switch checked={isFinancialModeEnabled} onChange={handleToggle} color="primary" disabled={loading} />
      </h4>
    </div>
  );
};
